export var WalletManagementEvent;
(function (WalletManagementEvent) {
    WalletManagementEvent["WalletConnected"] = "walletConnected";
})(WalletManagementEvent || (WalletManagementEvent = {}));
//# sourceMappingURL=events.js.map